/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { customsClearanceTypes } from "redux/types";

const setIdShowCustoms = (payload) => {
  return {
    type: customsClearanceTypes.idShowCustoms,
    payload
  };
};

export { setIdShowCustoms };
